/**
 * Filter props to get aria-* or aria[A-Z]* props
 *
 * @param {*} allProps props to filter
 */
export const pickAriaProps = (allProps, options) => {
  const {
    except = []
  } = options || {};
  return Object.keys(allProps).filter(key => {
    const isAriaProp = key.match(/^aria-|^aria[A-Z]/);
    const isException = except.includes(key);
    return isAriaProp && !isException;
  }).reduce((out, key) => {
    // TypeScript requires a type assertion here because it's not aware that key is a key of T
    out[key] = allProps[key];
    return out;
  }, {});
};